import endpoints, { formatEndpoint } from '../endpoints';
import { RestManagerWithoutBaseUrl } from '../RestManager';
import { mapAssetObj } from './componentApiHelper';
import {
    handleGetAssetPropertiesConversion
} from './componentApiUoMHelper';
class assetActions {

    updateAsset(data) {
        const endpoint = formatEndpoint(endpoints.assetRename.updateAssetList,
            {
                assetId: data.id,
            }
        );
        return RestManagerWithoutBaseUrl.put(endpoint, mapAssetObj(data));
    }


    getAssetDetailsV2(asset) {
        const endpoint = formatEndpoint(endpoints.assetDetails.getAssetDetails,
            {
                assetID: asset.id
            }
        );
        return RestManagerWithoutBaseUrl
            .get(endpoint)
            .then(handleGetAssetPropertiesConversion);
    }

    exportExcelForMeasurementTypeGroup(asset, params) {
        const endpoint = formatEndpoint(endpoints.component.exportExcelForMeasurementTypeGroup,
            {
                assetId: asset.id,
                from: params.from,
                to: params.to
            }
        );

        return RestManagerWithoutBaseUrl.post(endpoint, params.measurementTypes
        );
    }

    collectRawData(assetId) {
        const endpoint = formatEndpoint(endpoints.component.collectRawData, {
            assetId,
        });
        return RestManagerWithoutBaseUrl.post(endpoint);
    }


    loadMeasurement(assetId) {
        const endpoint = formatEndpoint(endpoints.component.loadMeasurement, {
            assetId,
        });
        return RestManagerWithoutBaseUrl.post(endpoint);
    }

    getSensorLastCommand(assetId, requestType) {
        const endpoint = formatEndpoint(endpoints.component.getSensorLastCommand, {
            assetId,
            requestType
        });
        return RestManagerWithoutBaseUrl.get(endpoint);
    }

    getSensorOfAssets(assetIds) {
        const endpoint = formatEndpoint(endpoints.assetDetails.getSensorOfAssets);
        return RestManagerWithoutBaseUrl.post(endpoint, { assetIds });
    }

    getDriveEventsSummary(assetId, startTime, endTime) {
        const endpoint = formatEndpoint(endpoints.component.getDriveEventsCurrentDay, {
            assetId
        });
        if (startTime && endTime) {
            endpoint.url = `${endpoint.url}?startTime=${encodeURIComponent(startTime)}&endTime=${encodeURIComponent(endTime)}`;
        }
        return RestManagerWithoutBaseUrl.get(endpoint);
    }
}

export default new assetActions();
